// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2JYd0","alertIcon":"ConfirmModal_alertIcon__2uV-W"};